import React from 'react';
import { Block, Help, Input, Label, Tooltip } from '@upsales/components';
import T from 'Components/Helpers/translate';
import EmailDuplicateWarning from './EmailDuplicateWarning';
import type { EditContactEmail } from './useEditContactEmail';
import type { FormObserverOnFieldChange } from '../FormObserver/FormObserver';
import type { MappedContact } from './editContactHelpers';

type Props = {
	email: EditContactEmail;
	value: string;
	client: MappedContact['client'];
	contactId?: number;
	required: boolean;
	submitted: boolean;
	onChange: FormObserverOnFieldChange;
};

const EmailField = ({ email, value, client, contactId, required, submitted, onChange }: Props) => (
	<div>
		<Label required={required}>{T('default.email')}</Label>
		<Input
			name="email"
			value={value || ''}
			icon="envelope"
			required={required}
			state={submitted && required && !value ? 'error' : undefined}
			style={{ color: email.showUnBounce && value === email.originalEmail ? 'red' : undefined }}
			onChange={e => {
				onChange('email', e.target.value);
				email.validateEmail(client, contactId, e.target.value);
			}}
		/>
		{email.showSuggestionWarning ? (
			<EmailDuplicateWarning
				duplicates={email.suggestionDuplicates}
				selectedDuplicate={email.selectedDuplicate}
				connecting={email.connectingContact}
				currentClientId={client?.id}
				filteredListLink={email.getFilteredListLink(value)}
				getContactLink={email.getContactLink}
				getCompanyLink={email.getCompanyLink}
				onSelect={email.setSelectedDuplicate}
				onEdit={email.editDuplicatedContact}
				onConnect={duplicate => email.connectExistingContact(duplicate, client)}
			/>
		) : null}
		{email.showSuggestion && email.suggestEmail ? (
			<div id="emailSuggestion" className="email-suggestion show-email-suggestion">
				<div className="email-section">
					<label>{`${T('default.suggestion')}: `}</label>
					<span>{email.suggestEmail}</span>
				</div>
				<div className="insert-section">
					<button
						type="button"
						className="btn btn-sm up-btn main-action btn-primary-action"
						onClick={() => email.insertSuggestEmail(onChange)}
					>
						{T('editor.dialogInsert')}
					</button>
					<Help articleId={1005} sidebar />
				</div>
			</div>
		) : null}
		{email.showUnBounce && value === email.originalEmail ? (
			<Tooltip position="right" disabled={!email.unBounceTooltip} title={email.unBounceTooltip}>
				<Block space="mtl" style={{ display: 'inline-block' }}>
					<button
						type="button"
						className="Button up-btn btn-super-light-green no-shadow"
						disabled={!!email.unBounceTooltip || email.unBouncing}
						onClick={() => email.onUnBounceContact(value)}
					>
						<i className="Icon Icon-email-bounce Block--margin-right-medium" />
						{T('email.unbounceAdress')}
					</button>
				</Block>
			</Tooltip>
		) : null}
	</div>
);

export default EmailField;
